import script from "./documents-item-metric.vue?vue&type=script&setup=true&lang=ts"
export * from "./documents-item-metric.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__